import React, { useEffect, useState } from 'react';

import { VisitPackSearch } from './VisitPackSearch';
import { FormsForVisit } from './FormsForVisit';

import './FormAssignments.css';

export const FormAssignments = ({
  visits,
  setVisits,
  visit,
  setVisit,
  forms,
  showToaster,
  context,
  setSpinnerText,
  showVisitForms,
  editMode,
  setVisitCodeEdited,
  study,
  enrolmentVisitAllowed = true,
  scheduleHasParticipantsLinked = false,
}) => {
  const [showFormsForVisit, setShowFormsForVisit] = useState(false);

  useEffect(() => {
    if (editMode) {
      setShowFormsForVisit(showVisitForms);
      setVisit(visits[0]);
    }
  }, [editMode, setShowFormsForVisit, setVisit, showVisitForms, visits]);

  return (
    <div className="form-assignment-container">
      <div className="visit-pack-search-container">
        <VisitPackSearch
          setShowFormsForVisit={setShowFormsForVisit}
          visits={visits}
          setVisits={setVisits}
          visit={visit}
          setVisit={setVisit}
          forms={forms}
          context={context}
          setSpinnerText={setSpinnerText}
          showToaster={showToaster}
          edit={editMode}
          setVisitCodeEdited={setVisitCodeEdited}
          study={study}
          enrolmentVisitSet={visits.some((visit) => visit.enrolmentVisit)}
          enrolmentVisitAllowed={enrolmentVisitAllowed}
          scheduleHasParticipantsLinked={scheduleHasParticipantsLinked}
        />
      </div>

      {showFormsForVisit && (
        <div className="visit-pack-forms-search-container">
          <FormsForVisit
            visit={visit}
            forms={forms}
            setVisit={setVisit}
            visits={visits}
            showToaster={showToaster}
            context={context}
            setSpinnerText={setSpinnerText}
            editMode={editMode}
            setVisits={setVisits}
          />
        </div>
      )}
    </div>
  );
};
